module.exports = __webpack_public_path__ + "static/background-66dda9d8c768ee66f575bfc17082e9db.gif";